import { Appearance, Design, Id, PrintArea } from '@/types';
import { isPixelDesign } from '@/model/design/isDesignType';
import { isUploadedDesign } from '@/model/design/isUploadedDesign';
import { getPrintTypesOfAppearance } from '@/model/productType/getPrintTypesOfAppearance';
import { getHasScreenPrintingPrintType } from './getHasScreenPrintingPrintType';
import { ScreenPrint } from './printTypes';
import { printTypesFor } from './printTypesFor';

function filterDesignPrintTypes(design: Design, appearance: Appearance): Id[] {
  // remove screen printing for all designs if the appearance has screen printing
  // and the design is a pixel design from the design gallery (means: is not uploaded by the user)
  if (
    !isUploadedDesign(design) &&
    isPixelDesign(design) &&
    getHasScreenPrintingPrintType(getPrintTypesOfAppearance(appearance))
  ) {
    return design.printTypes.filter((pt) => pt.id !== ScreenPrint);
  }
  return design.printTypes;
}

export const printTypesForDesign = (
  design: Design,
  printArea: PrintArea | undefined,
  appearance: Appearance,
  rotation = 0,
  scale?: number
) => {
  if (!printArea) {
    return [];
  }

  const {
    size: designSize,
    restrictions: { allowScale, minimumScale },
  } = design;
  // use minimum scale if none is given, to get the broadest possible set of print types
  const minScale = minimumScale / 100 || 1;
  const scaleForPrintabilityCheck = scale ? scale : minScale;

  return printTypesFor(
    printArea,
    appearance,
    filterDesignPrintTypes(design, appearance).map((pt) => pt.id),
    designSize,
    rotation,
    scaleForPrintabilityCheck,
    scaleForPrintabilityCheck < minScale,
    allowScale
  );
};
